// 页头高度
const HEADER_HEIGHT = 50;

export default function tableMixins(otherHeight,{refName}={}) {
  return {
    data() {
      return {
        windowHeight: document.documentElement.clientHeight,
        searchHeight: 0
      };
    },
    computed: {
      tableHeight() {
        const isHideMenu = sessionStorage.getItem('isHideMenu') == 1;
        const extraHeight = (this.otherHeight || otherHeight) - (isHideMenu ? HEADER_HEIGHT : 0);
        return this.windowHeight - extraHeight - this.searchHeight;
      },
    },
    methods: {
      table_mixins_resize() {
        this.windowHeight = document.documentElement.clientHeight;
        this.setSearchHeight();
      },
      setSearchHeight() {
        if(refName){
          const ref = this.$refs[refName] || this.$parent.$refs[refName];
          let showTaoAlertHeight = 0
          if(document.querySelector('.el-alert')){ // 针对商品中心页面顶部的提示信息处理
            showTaoAlertHeight = (document.querySelector('.el-alert').offsetHeight || 0)+16;
          }
          this.searchHeight = ref.$el.offsetHeight + showTaoAlertHeight;
        }
      },
    },
    watch: {
      isChannel(v) {
        if(v == 'disPrice') {
          this.searchHeight = document.querySelector('.skuBtns').offsetHeight + 20;
        }
      }
    },
    mounted() {
      this.setSearchHeight();
      window.addEventListener("resize", this.table_mixins_resize);
    },
    beforeDestroy() {
      window.removeEventListener("resize",this.table_mixins_resize);
    },
  };
}
